import React, { useEffect, useState } from 'react';

import isNode from 'detect-node';

export enum OverflowDirection {
  X = 'X',
  Y = 'Y',
  EITHER = 'EITHER',
}

// This hook currently will not handle updates if the user changes their browser size.
export function useElementIsOverflowing(
  elementRef: React.RefObject<HTMLDivElement | null> | null,
  direction: OverflowDirection,
  deps: any[] = [],
  correctionFactor = 0,
): boolean {
  const [state, setState] = useState<boolean>(false);

  useEffect(() => {
    const element = elementRef ? elementRef.current : null;
    if (!isNode && element) {
      if (direction === OverflowDirection.X || direction === OverflowDirection.EITHER) {
        setState(element.scrollWidth > element.offsetWidth);
      } else if (direction === OverflowDirection.Y || direction === OverflowDirection.EITHER) {
        setState(element.scrollHeight > element.offsetHeight + correctionFactor);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementRef, direction, ...deps]);

  return state;
}
